namespace TabAurous.Production {
    export interface DismantlingRow {
        TransId?: number;
        TransDate?: string;
        VoucherNo?: string;
        VoucherTypeId?: number;
        TermsId?: number;
        CurrencyId?: number;
        ExchRate?: number;
        NetAmount?: number;
        Roundoff?: number;
        TaxAmount?: number;
        Discount?: number;
        AdditionalCharges?: number;
        GrossAmount?: number;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        DiamondPieces?: number;
        DiamondWeight?: number;
        StonePieces?: number;
        StoneWeight?: number;
        OtherPieces?: number;
        OtherWeight?: number;
        Remark?: string;
        CompanyId?: number;
        EmployeeId?: number;
        FinancialYearId?: number;
        UserId?: number;
        Username?: string;
        ItemDetails?: DismantlingItemsRow[];
        ProductItemImage?: string;
        PostingDate?: string;
        IsPosted?: boolean;
        AutoPosting?: boolean;
    }

    export namespace DismantlingRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Production.Dismantling';
        export const deletePermission = 'Production:Dismantling:Delete';
        export const insertPermission = 'Production:Dismantling:Add';
        export const readPermission = '*';
        export const updatePermission = 'Production:Dismantling:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            TermsId = "TermsId",
            CurrencyId = "CurrencyId",
            ExchRate = "ExchRate",
            NetAmount = "NetAmount",
            Roundoff = "Roundoff",
            TaxAmount = "TaxAmount",
            Discount = "Discount",
            AdditionalCharges = "AdditionalCharges",
            GrossAmount = "GrossAmount",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            DiamondPieces = "DiamondPieces",
            DiamondWeight = "DiamondWeight",
            StonePieces = "StonePieces",
            StoneWeight = "StoneWeight",
            OtherPieces = "OtherPieces",
            OtherWeight = "OtherWeight",
            Remark = "Remark",
            CompanyId = "CompanyId",
            EmployeeId = "EmployeeId",
            FinancialYearId = "FinancialYearId",
            UserId = "UserId",
            Username = "Username",
            ItemDetails = "ItemDetails",
            ProductItemImage = "ProductItemImage",
            PostingDate = "PostingDate",
            IsPosted = "IsPosted",
            AutoPosting = "AutoPosting"
        }
    }
}
